<template>
  <div class="video-container">
    <template v-if="videoList.length > 0">
      <div class="container">
        <div
          class="video"
          v-for="(item, index) in videoList"
          :key="index"
          @click="goDetails(item)"
        >
          <div class="img">
            <img v-lazy="$global.imgUrl + item.cover" alt="" />
            <p>
              <span class="duration">aa{{ item.videoLong }}</span>
              <span class="watch"
                ><img v-lazy="require('@/assets/img/qietu/see.png')" alt="" />{{
                  item.view
                }}</span
              >
            </p>
          </div>
          <div class="content">{{ item.title }}</div>
        </div>
      </div>
    </template>
    <NoData v-if="videoList.length <= 0 && setFlag"></NoData>
    <Spin fix v-if="flag">
      <Icon type="ios-loading" size="28" class="demo-spin-icon-load"></Icon>
    </Spin>
  </div>
</template>

<script>
import NoData from "@/views/PCView/search/components/NoData.vue";
export default {
  components: {
    NoData,
  },
  data() {
    return {
      setFlag: false,
      flag: true,
      // 分页
      curPage: 1,
      total: 0,
      limit: 0,
      videoList: [],
      params: {
        cid: this.$route.query.id,
        pid: JSON.parse(sessionStorage.getItem("Table"))
          ? JSON.parse(sessionStorage.getItem("Table")).PlatformEnum[0].id
          : 1,
        pageNo: 1,
        pageSize: 10,
      },
      scrollFlag: true,
      nowDateBool: false,
    };
  },
  created() {
    this.articleVideoList(this.params);
  },
  mounted() {
    this.$bus.$on("mainScroll", this.handlePager);
  },
  beforeDestroy() {
    this.$bus.$off("mainScroll", this.handlePager);
  },
  methods: {
    goDetails(e) {
      let routeUrl = this.$router.resolve({
        path: "videoDetails",
        query: {
          type: "7",
          id: e.id,
          cid: this.$route.query.id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    async articleVideoList(data) {
      const resp = await this.$apis.searchServe.articleVideoList(data);
      this.total = +resp.data.total;
      this.limit = +resp.data.pageSize;
      this.flag = false;
      this.setFlag = true;
      if (resp.data.list) {
        this.videoList.push(...resp.data.list);
      }
      this.curPage++;
      if (
        ((resp.data.list && resp.data.list.length == 0) || !resp.data.list) &&
        this.nowDateBool
      ) {
        this.$Message.warning("数据加载完毕");
        this.scrollFlag = false;
      }
    },
    handlePager() {
      let containerHeight =
        document.documentElement.clientHeight +
        document.documentElement.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight;
      if (containerHeight + 1 >= scrollHeight && this.scrollFlag) {
        console.log("到底了");
        this.nowDateBool = true;
        this.articleVideoList({
          ...this.params,
          pageNo: this.curPage,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.video-container {
  position: relative;
  .container {
    width: 1200px;
    background: #ffffff;
    box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    .video {
      width: 270px;
      height: 220px;
      margin: 10px 0;
      &:not(:nth-child(4n)) {
        margin-right: 25px;
      }
      .img {
        width: 270px;
        height: 151px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }
        p {
          width: 100%;
          padding: 0 17px;
          position: absolute;
          bottom: 16px;
          font-size: 12px;
          font-weight: bold;
          color: #ffffff;
          display: flex;
          justify-content: space-between;
          .watch {
            img {
              width: 13px;
              height: 10px;
            }
          }
        }
      }
      .content {
        margin-top: 26px;
        font-size: 14px;
        color: #333333;
      }
    }
  }
}
</style>
